import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const SidebarBrandList = () => {
    const [loadingBrands, setLoadingBrands] = useState(true);
    const [error, setError] = useState(null);
    const [brands, setBrands] = useState([]);

    const fetchBrands = useCallback(async () => {
        try {
            setLoadingBrands(true);
            const url = new URL('/api/products/vendors/index', process.env.APP_URL);
            const response = await fetch(url);
            const data = await response.json();
            if (data.error) {
                throw new Error(data.error);
            }
            setBrands(data.vendors);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoadingBrands(false);
        }
    }, []);

    useEffect(() => {
        fetchBrands();
    }, []);

    if (loadingBrands) {
        return (
            <div
                className={'p-2'}>Loading brands...</div>
        );
    } else if (error) {
        return (
            <div
                className={'p-2'}>Error loading brands: {error}</div>
        );
    }
    return (
        <div
            className={'page-sidebar--brands'}>
            {brands.map((brand, index) => (
                <div
                    key={`${brand.name}-${index}`}>
                    <Link
                        to={`/brands/${brand.name}`}
                        className={'page-sidebar--link'}
                    >
                        {brand.name}
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default SidebarBrandList;